export default __webpack_public_path__ + "static/media/phases.a73bdccc.svg";